import axios from "axios";

const API = axios.create({ baseURL: "https://oneconverse.herokuapp.com/" }); // ALWAYS REMEMBER TO ADJUST TO https://oneconverse.herokuapp.com/ FOR PRODUCTION

API.interceptors.request.use((req) => {
  if (localStorage.getItem("auth")) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem("auth")).token
    }`;
  }

  return req;
});

export const awaiting = (update) => API.patch("/awaiting", update);

export const translate = (translate) => API.post("/translate", translate);

export const counter = (update) => API.patch("/counter", update);
export const getCounter = () => API.get("/counter");

export const createProject = (project) =>
  API.post("/project/createProject", project);
export const getProjectsOther = (project) =>
  API.post("/project/getProjects", project);
export const updateProject = (id, update) =>
  API.patch(`/project/${id}`, update);

export const updateQuote = (id, update) => API.patch(`/quote/${id}`, update);
export const getQuotes = (data) => API.post("/quote/quotes", data);
export const getProjects = (data) => API.post("/quote/getProjects", data);
export const getOneQuote = (data) => API.post(`/quote/getOne`, data);
export const createQuote = (quote) => API.post("/quote", quote);
export const getFiles = (id) => API.get(`/quote/file/${id}`);
export const getTranslations = (id) => API.get(`/quote/translations/${id}`);
export const getApproved = (id) => API.get(`/quote/approved/${id}`);
export const issueInvoice = (update) => API.post("/quote/issueInvoice", update);
export const getWordCount = (file) => API.post("/quote/count", file, {});

export const signIn = (data) => API.post("/user/signin", data);
export const signUp = (data) => API.post("/user/signup", data);
export const getTranslators = (data) => API.post("/user/getTranslators", data);
export const getUser = (data) => API.post("/user/getUser", data);
export const changeEmail = (update) => API.post(`/user/changeEmail`, update);
export const changePassword = (update) =>
  API.post(`/user/changePassword`, update);
export const updateUser = (id, update) => API.patch(`/user/${id}`, update);
export const deleteUser = (username) => API.delete(`/user/${username}`);
export const confirmEmail = (update) => API.post(`/user/confirmEmail`, update);
export const resetPassword = (update) =>
  API.post(`/user/resetPassword`, update);

export const sendEmail = (update) => API.post("/mail/sendEmail", update);
export const contactUs = (update) => API.post("/mail/contactUs", update);
export const sendAuthEmail = (update) =>
  API.post(`/mail/sendAuthEmail`, update);
export const sendInvoiceEmail = (update) =>
  API.post(`/mail/sendInvoiceEmail`, update);
export const resetPasswordEmail = (update) =>
  API.post("/mail/resetPasswordEmail", update);
